/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
export type SetOutageFeeAppliesPayload = {
    outageFeeApplies: SetOutageFeeAppliesPayload.outageFeeApplies;
    slotBookableAgain?: boolean;
    paidAt?: DateTime;
    paymentType?: SetOutageFeeAppliesPayload.paymentType;
};
export namespace SetOutageFeeAppliesPayload {
    export enum outageFeeApplies {
        YES = 'yes',
        NO = 'no',
        NOT_SELECTED = 'not-selected',
    }
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
}

